import "core-js/modules/es.array.push.js";
// import reqwest from 'reqwest'
import axios from '../store/interface';
import { message } from 'ant-design-vue';
import { lang } from '@/locales';
export default {
  name: 'index',
  data() {
    return {
      account: 'admin',
      password: '123456',
      form: {
        account: '',
        name: '',
        password: '',
        verification_code: '',
        type: 1,
        current_locate: 1,
        team_number: '',
        user_type: this.$route.params.type === '1' ? '10' : '20' // 默认选中的用户10 供应商20
      },
      accountType: this.$route.params.type,
      labelCol: {
        span: 7
      },
      wrapperCol: {
        span: 17
      },
      size: 'large',
      // 是否禁用按钮
      codeDisabled: false,
      // 倒计时秒数
      countdown: 60,
      // 按钮上的文字
      codeMsg: lang('get_ver_code'),
      // 定时器
      timer: null,
      rules: {
        name: [{
          required: true,
          message: lang('ph_name'),
          trigger: 'blur'
        }],
        team_number: [{
          required: true,
          message: lang('ph_tissue_id'),
          trigger: 'blur'
        }],
        country: [{
          required: true,
          message: lang('choose_country'),
          validator: this.validatePass3,
          trigger: 'change'
        }],
        password: [{
          required: true,
          validator: async (rule, value) => {
            // 长度为8~14个字符
            // 字母数字以及标点符号至少包含2种
            // 不允许有空格、中文
            // let count = 0
            const rules = /(?!^[0-9]+$)(?!^[A-z]+$)(?!^[^A-z0-9]+$)^[^\s\u4e00-\u9fa5]{8,14}$/;
            // console.log(rule, value, rules.test(value))
            if (value === '') {
              return Promise.reject(lang('ph_pass'));
            } else if (!rules.test(value)) {
              // if (value.length < 8 || value.length > 14) {
              // return Promise.reject('长度为8~14个字符')
              return Promise.reject(lang('tip_pass'));
            } else {
              return Promise.resolve();
            }
          },
          trigger: 'change'
        }],
        // password: [
        //   { required: true, message: lang('ph_pass'), trigger: 'change' }
        // ],
        repassword: [{
          required: true,
          validator: this.validatePass2,
          trigger: 'change'
        }],
        account: [{
          required: true,
          message: lang('ph_phone'),
          trigger: 'blur'
        }],
        checkEmail: [{
          required: true,
          validator: async (rule, value) => {
            console.log(rule, value);
            if (value === '') {
              return Promise.reject(lang('ph_email'));
            }
            // const emailRule = /^\w+(\.)?(\w+)?@[0-9a-z]+(\.[a-z]+){1,3}$/
            // if (!emailRule.test(value)) {
            //   return Promise.reject('邮箱格式不正确')
            // }
          },
          trigger: 'change'
        }],
        verification_code: [{
          required: true,
          message: lang('ph_ver_code'),
          trigger: 'blur'
        }]
      },
      countryList: []
    };
  },
  created() {
    console.log('created', this.$route.params);
  },
  mounted() {
    this.getCountryList();
  },
  methods: {
    save() {
      // 错误校验
      if (!this.form.country_id) {
        message.warning(lang('tip_choose_country'));
        return false;
      }
      if (!this.form.name) {
        message.warning(lang('ph_name'));
        return false;
      }
      if (this.form.type == 1) {
        if (!this.form.account) {
          message.warning(lang('ph_phone'));
          return false;
        }
        const phone = /^1(3\d|4[5-9]|5[0-35-9]|6[2567]|7[0-8]|8\d|9[0-35-9])\d{8}$/;
        if (!phone.test(this.form.account)) {
          message.warning(lang('tip_phone_format'));
          return;
        }
      } else {
        const email = /^\w+(\.)?(\w+)?@[0-9a-z]+(\.[a-z]+){1,3}$/;
        if (!this.form.account) {
          message.warning(lang('ph_email'));
          return false;
        }
        if (!email.test(this.form.account)) {
          message.warning(lang('tip_email_format'));
          return false;
        }
      }
      if (!this.form.password) {
        message.warning(lang('ph_pass'));
        return false;
      }
      if (this.form.password.length < 8) {
        message.warning(lang('tip_pass_len'));
        return false;
      }
      const passwordrule = /(?!^[0-9]+$)(?!^[A-z]+$)(?!^[^A-z0-9]+$)^[^\s\u4e00-\u9fa5]{8,14}$/;
      if (!passwordrule.test(this.form.password)) {
        message.warning(lang('tip_pass'));
        return false;
      }
      if (!this.form.repassword) {
        message.warning(lang('ph_confirm_pass'));
        return false;
      }
      if (this.form.password != this.form.repassword) {
        message.warning(lang('tip_pass_match'));
        return false;
      }
      if (this.form.type == 1 && this.form.country_id == 44 && !this.form.verification_code) {
        message.warning(lang('ph_ver_code'));
        return false;
      }
      this.form.team_number = this.form.team_number.replace(/\s/g, ''); // 去掉空格
      this.fetch(this.form);
    },
    goToLogin() {
      this.accountType = this.form.user_type === '10' ? '1' : '2'; // 默认选中的用户10 供应商20
      this.$router.push('/login/' + this.accountType);
    },
    getCountryList() {
      // reqwest({
      //   url: process.env.VUE_APP_BASE_URL + 'manage/auth/countries',
      //   method: 'get',
      //   crossOrigin: true
      // }).then(data => {
      //   if (data.code == 200) {
      //     this.countryList = data.data
      //   }
      // })
      const promise = new Promise((resolve, reject) => {
        axios({
          method: 'get',
          url: process.env.VUE_APP_BASE_URL + 'manage/auth/countries',
          params: {
            account: this.form.account
          }
        }).then(function (data) {
          resolve(data.data);
        });
      });
      promise.then(result => {
        this.countryList = result.data;
      });
    },
    fetch(params = {}) {
      // reqwest({
      //   url: process.env.VUE_APP_BASE_URL + 'manage/auth/register',
      //   method: 'post',
      //   data: {
      //     ...params
      //   },
      //   type: 'json',
      //   crossOrigin: true
      // }).then(data => {
      //   if (data.code == 200) {
      //     if (this.form.type == 2) {
      //       message.success('lang('tip_emial_success'))
      //     } else {
      //       message.success(lang('tip_register_sucess'))
      //     }
      //     this.$router.push('/login')
      //   } else if (data.code == 400) {
      //     message.warning(data.message)
      //   }
      // })
      const promise = new Promise((resolve, reject) => {
        axios({
          method: 'post',
          url: process.env.VUE_APP_BASE_URL + 'manage/auth/register',
          params: {
            ...params
          }
        }).then(function (data) {
          resolve(data.data);
        });
      });
      promise.then(result => {
        if (result.code == 200) {
          if (this.form.type == 2) {
            message.success(lang('tip_emial_success'));
          } else {
            message.success(lang('tip_register_sucess'));
          }
          this.$router.push('/login/' + this.accountType);
        } else if (result.code == 400) {
          message.warning(result.message);
        }
      });
    },
    getCode() {
      if (this.timer) {
        return;
      }
      const phone = /^1(3\d|4[5-9]|5[0-35-9]|6[2567]|7[0-8]|8\d|9[0-35-9])\d{8}$/;
      if (!phone.test(this.form.account)) {
        message.warning(lang('tip_phone_format'));
        return;
      }
      const codeUrl = this.form.user_type === '10' ? 'manage/auth/sendcode' : 'manage/auth/suppliersendcode';
      const promise = new Promise((resolve, reject) => {
        axios({
          method: 'get',
          url: process.env.VUE_APP_BASE_URL + codeUrl,
          params: {
            account: this.form.account
          }
        }).then(function (data) {
          resolve(data.data);
        });
      });
      promise.then(result => {});
      // 验证码60秒倒计时
      if (!this.timer) {
        this.timer = setInterval(() => {
          if (this.countdown > 0 && this.countdown <= 60) {
            this.countdown--;
            if (this.countdown !== 0) {
              this.codeMsg = `${lang('resend')}(${this.countdown})`;
            } else {
              clearInterval(this.timer);
              this.codeMsg = lang('get_ver_code');
              this.countdown = 60;
              this.timer = null;
              this.codeDisabled = false;
            }
          }
        }, 1000);
      }
    },
    validatePass2(rule, value) {
      if (value === '') {
        return Promise.reject(lang('tip_repass'));
      } else if (value !== this.form.password) {
        return Promise.reject(lang('tip_pass_different'));
      } else {
        return Promise.resolve();
      }
    },
    validatePass3(rule, value) {
      if (value === '') {
        return Promise.reject(lang('tip_choose_country'));
      }
    },
    handleChange(val) {
      // console.log(val);
      if (val == 44) {
        this.form.type = 1;
      } else {
        this.form.type = 2;
      }
    },
    props: {
      msg: String
    }
  }
};